import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid} from 'views/components';
import {CardTable} from 'views/module';

import Card from './Card';

const List = (props) => {
  const {data, isLoading, loadMore, hasMore, highlightedCaregiverId} = props;

  return (
    <Grid container>
      <CardTable
        data={data}
        card={Card}
        isLoading={isLoading}
        loadMore={loadMore}
        hasMore={hasMore}
        highlightedId={highlightedCaregiverId}
        getItemId={(item) => item.caregiverRn}
      />
    </Grid>
  );
};
List.propTypes = {
  data: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  loadMore: PropTypes.func,
  hasMore: PropTypes.bool,
  visibleCaregiverIds: PropTypes.array,
  highlightedCaregiverId: PropTypes.string,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(List));
